import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import styled from 'styled-components';
import cx from 'classnames';
import { useInView } from 'react-intersection-observer';
import { useHover } from '@moim/common';

var Trigger = styled.div.withConfig({
  displayName: "Trigger",
  componentId: "sc-16jc2tf-0"
})(["position:absolute;top:0;bottom:0;left:0;right:0;pointer-events:none;"]);
function TransitionController(_ref) {
  var transition = _ref.transition,
    children = _ref.children;
  var _a;
  var _useInView = useInView({
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    hoverRef = _useHover2[0],
    isHover = _useHover2[1];
  var showAnimation = (transition === null || transition === void 0 ? void 0 : transition.type) === "hover" ? isHover : (transition === null || transition === void 0 ? void 0 : transition.type) === "landing" ? inView : false;
  if (!transition) {
    return jsx(Fragment, {
      children: children({})
    });
  }
  return jsxs(Fragment, {
    children: [jsx(Trigger, {
      ref: ref
    }), jsx(Trigger, {
      ref: hoverRef
    }), children({
      className: cx({
        animate__fadeIn: showAnimation && (transition === null || transition === void 0 ? void 0 : transition.value) === "fadeIn",
        animate__fadeInUp: showAnimation && (transition === null || transition === void 0 ? void 0 : transition.value) === "fadeInUp",
        animate__fadeInDown: showAnimation && (transition === null || transition === void 0 ? void 0 : transition.value) === "fadeInDown",
        animate__fadeInLeft: showAnimation && (transition === null || transition === void 0 ? void 0 : transition.value) === "fadeInLeft",
        animate__fadeInRight: showAnimation && (transition === null || transition === void 0 ? void 0 : transition.value) === "fadeInRight"
      }),
      styles: {
        animationDuration: "".concat((_a = transition === null || transition === void 0 ? void 0 : transition.duration) !== null && _a !== void 0 ? _a : 1000, "ms")
      }
    })]
  });
}

export { TransitionController as default };
